<script setup lang="ts">
import type { TagSize, TagVariant } from './types'

type Props = {
  variant?: TagVariant
  size?: TagSize
}

const props = withDefaults(defineProps<Props>(), {
  variant: 'primary',
  size: 'sm',
})

const componentClasses = computed(() => {
  return [
    'app-tag',
    `app-tag--variant-${props.variant}`,
    `app-tag--size-${props.size}`,
  ]
})
</script>

<template>
  <div :class="componentClasses">
    <the-icon name="fill-location" size="16" color="currentColor" />

    <span v-if="$slots.default" class="app-tag__text">
      <slot />
    </span>
  </div>
</template>

<style scoped lang="scss">
.app-tag {
  display: inline-flex;
  gap: 4px;
  align-items: center;
  border-radius: 120px;

  &__text {
    overflow: hidden;
    font-size: 12px;
    font-weight: 600;
    line-height: 16px;
    text-overflow: ellipsis;
    letter-spacing: 0.015em;
    white-space: nowrap;
  }

  &--variant-primary {
    color: var(--ui-color-primary);
    background-color: var(--ui-color-peach-fill);
  }

  &--variant-secondary {
    color: var(--ui-text-primary);
    background-color: var(--ui-color-sandy-50);
  }

  &--size-sm {
    padding: 4px 8px;
  }

  &--size-md {
    padding: 8px;
  }

  &--size-lg {
    padding: 12px;
  }
}
</style>
